export const NETBANKING_LIST = [
    {
        bankName: "Axis Bank",
        bankCode: "NB_AXIS",
        enabled: true,
    },
    {
        bankName: "Bank of India",
        bankCode: "NB_BOI",
        enabled: true,
    },
    {
        bankName: "Bank of Maharashtra",
        bankCode: "NB_BOM",
        enabled: true,
    },
    {
        bankName: "Central Bank Of India",
        bankCode: "NB_CBI",
        enabled: true,
    },
    {
        bankName: "Corporation Bank",
        bankCode: "NB_CORP",
        enabled: true,
    },
    {
        bankName: "Development Credit Bank",
        bankCode: "NB_DCB",
        enabled: true,
    },
    {
        bankName: "Federal Bank",
        bankCode: "NB_FED",
        enabled: true,
    },
    {
        bankName: "ICICI Netbanking",
        bankCode: "NB_ICICI",
        enabled: true,
    },
    {
        bankName: "Industrial Development Bank of India",
        bankCode: "NB_IDBI",
        enabled: true,
    },
    {
        bankName: "Indian Bank",
        bankCode: "NB_INDB",
        enabled: true,
    },
    {
        bankName: "IndusInd Bank",
        bankCode: "NB_INDUS",
        enabled: true,
    },
    {
        bankName: "Indian Overseas Bank",
        bankCode: "NB_IOB",
        enabled: true,
    },
    {
        bankName: "Jammu and Kashmir Bank",
        bankCode: "NB_JNK",
        enabled: true,
    },
    {
        bankName: "Karnataka Bank",
        bankCode: "NB_KARN",
        enabled: true,
    },
    {
        bankName: "Karur Vysya",
        bankCode: "NB_KVB",
        enabled: true,
    },
    {
        bankName: "State Bank of Bikaner and Jaipur",
        bankCode: "NB_SBBJ",
        enabled: true,
    },
    {
        bankName: "State Bank of India",
        bankCode: "NB_SBI",
        enabled: true,
    },
    {
        bankName: "State Bank of Mysore",
        bankCode: "NB_SBM",
        enabled: true,
    },
    {
        bankName: "South Indian Bank",
        bankCode: "NB_SOIB",
        enabled: true,
    },
    {
        bankName: "Union Bank of India",
        bankCode: "NB_UBI",
        enabled: true,
    },
    {
        bankName: "United Bank Of India",
        bankCode: "NB_UNIB",
        enabled: true,
    },
    {
        bankName: "Vijaya Bank",
        bankCode: "NB_VJYB",
        enabled: true,
    },
    {
        bankName: "Yes Bank",
        bankCode: "NB_YESB",
        enabled: true,
    },
    {
        bankName: "CityUnion",
        bankCode: "NB_CUB",
        enabled: true,
    },
    {
        bankName: "Canara Bank",
        bankCode: "NB_CANR",
        enabled: true,
    },
    {
        bankName: "State Bank of Patiala",
        bankCode: "NB_SBP",
        enabled: true,
    },
    {
        bankName: "Deutsche Bank",
        bankCode: "NB_DEUT",
        enabled: true,
    },
    {
        bankName: "Kotak Bank",
        bankCode: "NB_KOTAK",
        enabled: true,
    },
    {
        bankName: "Dhanalaxmi Bank",
        bankCode: "NB_DLS",
        enabled: true,
    },
    {
        bankName: "ING Vysya Bank",
        bankCode: "NB_ING",
        enabled: true,
    },
    {
        bankName: "Syndicate Bank",
        bankCode: "NB_SYNB",
        enabled: true,
    },
    {
        bankName: "UCO Bank",
        bankCode: "NB_UCOB",
        enabled: true,
    },
    {
        bankName: "Allahabad Bank",
        bankCode: "NB_ALLB",
        enabled: true,
    },
    {
        bankName: "Janata Sahakari Bank",
        bankCode: "NB_JSB",
        enabled: true,
    },
    {
        bankName: "Lakshmi Vilas Bank Retail",
        bankCode: "NB_LVB",
        enabled: true,
    },
    {
        bankName: "North Kanara GSB",
        bankCode: "NB_NKGSB",
        enabled: true,
    },
    {
        bankName: "Punjab and Sind Bank",
        bankCode: "NB_PNJSB",
        enabled: true,
    },
    {
        bankName: "Ratnakar Bank",
        bankCode: "NB_RATN",
        enabled: true,
    },
    {
        bankName: "Royal Bank of Scotland",
        bankCode: "NB_RBS",
        enabled: true,
    },
    {
        bankName: "DENA Bank",
        bankCode: "NB_DENA",
        enabled: true,
    },
];

export const LAZY_PAY_META = {
    name: "PayLater_Lazypay",
    displayName: "LazyPay",
    iconUrl: "LP-Logo_yeciem",
    paymentCode: "PayLater_Lazypay",
    tncUrl: "https://www.lazypay.in/tnc.html",
    text: "LazyPay lets you Order Now and Pay Later for your purchase.",
    points: [
        {
            iconUrl: "lazypay_asset1_yv1qy2",
            text: "Faster checkout",
        },
        {
            iconUrl: "lazypay_asset2_muy8fi",
            text: "We'll pay for you at no extra cost",
        },
        {
            iconUrl: "lazypay_asset3_yauszg",
            text: "Flexibility to Pay Later at your convenience",
        },
    ],
    dueDateInfoMessage: "",
};

export const options = {
    weAcceptAllLogos: {
        visa: { enabled: 1, id: "PaymentLogos/Cards/2021_10/visa" },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        master_card: { enabled: 1, id: "PaymentLogos/Cards/2021_10/mastercard" },
        rupay: { enabled: 1, id: "PaymentLogos/Cards/2021_10/rupay" },
        amex: { enabled: 1, id: "PaymentLogos/Cards/2021_10/amex" },
        diners: { enabled: 1, id: "PaymentLogos/Cards/2021_10/Diners" },
        sodexo: { enabled: 1, id: "PaymentLogos/FoodCards/2021_10/Sodexo" },
    },
    weAcceptFoodCardLogos: {
        sodexo: { enabled: 1, id: "Sodexo_tfxihv" },
        zeta: { enabled: 1, id: "Zeta_zybqrc" },
        tktRestaurant: { enabled: 1, id: "3xTICKET_RESTAURANT_th5woq" },
    },
    weAcceptNonFoodCardLogos: {
        visa: { enabled: 1, id: "PaymentLogos/Cards/2021_10/visa" },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        master_card: { enabled: 1, id: "PaymentLogos/Cards/2021_10/mastercard" },
        rupay: { enabled: 1, id: "PaymentLogos/Cards/2021_10/rupay" },
        amex: { enabled: 1, id: "PaymentLogos/Cards/2021_10/amex" },
        diners: { enabled: 1, id: "PaymentLogos/Cards/2021_10/Diners" },
    },
    lazyPayMeta: LAZY_PAY_META,
};

export const POLLING_CONFIG = {
    pollingDurationInMS: 300000,
    pollingIntervalInMS: 3000,
    txnStatusPollingIntervalInMS: 1000,
    defaultUpiPollingDuration: 15000,
    defaultCredPollingDuration: 15000,
    defaultCardPollingDuration: 15000,
};

export type SwgyOptions = typeof options;
